import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) { config.headers = config.headers || {}; config.headers.Authorization = `Bearer ${token}`; }
  return config;
});

export async function listLabor() {
  const { data } = await client.get('/labor');
  return data; // { items, metrics }
}
export async function createLabor(payload) {
  const { data } = await client.post('/labor', payload);
  return data.item;
}
export async function updateLabor(id, payload) {
  const { data } = await client.patch(`/labor/${id}`, payload);
  return data.item;
}
export async function deleteLabor(id) {
  await client.delete(`/labor/${id}`);
}
